import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueI18n from 'vue-i18n'
// elementUI组件
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 中英文切换
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// 动画样式库
import animated from 'animate.css'
// swiper组件样式
import 'swiper/css/swiper.css'
// 路由组件
import router from './router'
// 滚动动画 wow.js
// import { WOW } from 'wowjs';

Vue.use(VueI18n)
const lang = window.sessionStorage.getItem('language') || 'zh'
const i18n = new VueI18n({
  locale: lang,
  messages: {
    'en': Object.assign(require('./assets/lang/en.js'), enLocale), // 将我们项目中的语言包与Element的语言包进行合并
    'zh': Object.assign(require('./assets/lang/zh.js'), zhLocale)
  }
})
Vue.use(animated)
Vue.use(VueAwesomeSwiper)
Vue.use(Element, { i18n: (key, value) => i18n.t(key, value) })
// 设置超时时间
axios.defaults.timeout = 5000
// 设置api地址
// 全局定义axios
Vue.prototype.$http = axios
Vue.prototype.apiserver = ''
Vue.prototype.isDevelop = !1
Vue.prototype.domainUrl = 'https://www.cnano.com.cn'
/*
Vue.prototype.$wow = new WOW({
    boxClass: 'wow', // default
    animateClass: 'animated', // default
    offset: 0, // default
    mobile: true, // default
    live: true,
    callback: function (box) {
        console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
    }
});
*/

document.title = '江苏超电新能源科技发展有限公司'
router.afterEach((to) => {
  if (to.name != 'solutions') {
    window.scrollTo(0, 0)
  }
})

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
